module.exports = "/lucky-balls/img/regular_game/check_infoBar/check_013.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/regular_game/check_infoBar/check_013.png
// module id = 1137
// module chunks = 0